module.exports = __webpack_public_path__ + "static/media/main_service.878a686a.mp4";